import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

const root = createRoot(document.getElementById('root')!)

async function render() {
  if (window.location.pathname === '/dev') {
    if (!import.meta.env.DEV) {
      root.render(<p>Not available.</p>)
      return
    }
    const { default: DevPlayground } = await import('./dev-previews/DevPlayground')
    root.render(<StrictMode><DevPlayground /></StrictMode>)
    return
  }
  root.render(<StrictMode><App /></StrictMode>)
}

void render()
